import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { GetFinancialRecordDto } from "../../shared/dtos/FichaFinanceira.dto";

import { LoadingContainer } from "./styles";

import {
  Table,
  TableContainer,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../Table/styles";
import {
  BlueTitle,
  LoadingGif,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../shared/styles/global.styles";
import loadSCGif from "../../assets/load_SC.gif";
import Swal from "sweetalert2";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import { formatarData } from "../../utils/dateUtils/dateUtils";
import { StatusImpressaoEnum, StatusRemessaEnum } from "../../shared/enum/fichaFinanceira.enum";
import Button from "../Button/button";
import { IoCloseSharp } from "react-icons/io5";

interface DetailsModalProps {
  show: boolean;
  onClose: () => void;
  record: GetFinancialRecordDto;
  setShowQrCodeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const DetailsModal: React.FC<DetailsModalProps> = ({
  show,
  onClose,
  record,
  setShowQrCodeModal,
}) => {
  const openModalQrCode = () => setShowQrCodeModal(true);
  const [isRequest, setIsRequest] = useState(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [selectedInstallments, setSelectedInstallments] = useState<
    GetFinancialRecordDto[]
  >([]);


  const [showManualClearanceModal, setShowManualClearanceModal] =
    useState<boolean>(false);

  const [showCancelInstallmentsModal, setShowCancelInstallmentsModal] =
    useState<boolean>(false);

  const [selectedSingleInstallment, setSelectedSingleInstallment] =
    useState<GetFinancialRecordDto | null>(null);

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const getRecibo = async (id: number) => {
    try {
      const response = await FichaFinanceiraService.getRecibo(id);
      setRecibo(response);
    } catch (error) {
      console.error("Erro ao buscar recibo:", error);
      return null;
    }
  };

  const [recibo, setRecibo] = useState<{
    id: number;
    numeroSequencial: string;
    createdAt: string;
    contribuinteId: number;
  } | null>(null);

  useEffect(() => {
    getRecibo(record.id);
  }, [record.id]);

  // const getPDFPaymentBill = async (url: string) => {
  //   try {
  //     window.open(`${process.env.REACT_APP_API_URL}pdfs/${url}`, "_blank");
  //   } catch (error) {
  //     console.error("Erro ao gerar PDF:", error);
  //     Swal.fire({
  //       title: "Erro",
  //       text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
  //       icon: "error",
  //     });
  //   }
  // };

  const createBillOfPay = async (
    fichasFinanceiras: GetFinancialRecordDto[]
  ) => {
    const data = {
      idFichaFinanceira: fichasFinanceiras.map((fichas) => fichas.id),
    };

    try {
      Swal.fire({
        title: "Carregando",
        text: "Carregando boletos...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await FichaFinanceiraService.createBillOfPay(data);
      if (response.success) {
        // Abrir o PDF
        window.open(
          `${process.env.REACT_APP_API_URL}pdfs/${response.data.nameFile}`,
          "_blank"
        );

        // Aguardar 1 segundo antes de deletar (tempo para o navegador abrir o PDF)
        setTimeout(async () => {
          const deleteResponse = await FichaFinanceiraService.deleteFileInPdfs(
            response.data.nameFile
          );

          if (deleteResponse.success) {
            setSelectedInstallments([]);
            const firstResult = await Swal.fire({
              title: "Sucesso!",
              text: "Os boletos foram carregados com sucesso!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });

            if (firstResult.isConfirmed) { 
              const result = await Swal.fire({
                title: "Sucesso!",
                text: `Deseja trocar o status da impressão para ${StatusImpressaoEnum.IMPRESSO}?`,
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                allowOutsideClick: false,
              });

              if (result.isConfirmed) {
                await FichaFinanceiraService.update(record.id, {
                  statusImpressao: StatusImpressaoEnum.IMPRESSO,
                });
                record.statusImpressao = StatusImpressaoEnum.IMPRESSO;
              }
            }
          }
        }, 2000); // tempo em milissegundos
      } else {
        Swal.fire({
          title: "Erro",
          text: "Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
      });
    }
  };

  const handleUpdate = async (
    id: number,
    statusImpressao: StatusImpressaoEnum
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da impressão",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        input: "select",
        inputOptions: {
          [StatusImpressaoEnum.A_IMPRIMIR]: "A Imprimir",
          [StatusImpressaoEnum.IMPRESSO]: "Impresso",
          [StatusImpressaoEnum.NAO_IMPRIMIR]: "Não Imprimir",
          [StatusImpressaoEnum.PENDENTE]: "Pendente",
        },
        inputValue: statusImpressao, // Define o status selecionado como padrão
        inputValidator: (value) => {
          if (value === statusImpressao) {
            return "Selecione uma opção diferente da atual";
          }
        },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status da impressão...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await FichaFinanceiraService.update(id, {
          statusImpressao: result.value,
        });

        record.statusImpressao = result.value;
        Swal.close();
      }
    } catch (error) {
      console.error("Erro ao trocar status da impressão:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da impressão",
      });
    }
  };


  const handleUpdateRemessa = async (
    id: number,
    statusRemessaAtual: string
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da remessa",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        input: "select",
        inputOptions: {
          [StatusRemessaEnum.ENVIAR]: "Enviar",
          [StatusRemessaEnum.NAO_ENVIAR]: "Não enviar",
          [StatusRemessaEnum.ENVIADA]: "Enviada",
        },
        inputValue: statusRemessaAtual, // Define o status selecionado como padrão
        inputValidator: (value) => {
          if (value === statusRemessaAtual) {
            return "Selecione uma opção diferente da atual";
          }
        },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status remessa...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await FichaFinanceiraService.update(id, {
          statusRemessa: result.value,
        });

        record.statusRemessa = result.value;

        Swal.close();
      }
    } catch (error) {
      console.error("Erro ao trocar status da remessa:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da remessa",
      });
    }
  };
  if (!show) return null;
  return (
    <ModalContainer show={show}>
      <ModalContent>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Detalhes da Ficha Financeira</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <TableContainer>
            {isRequest ? (
              <LoadingContainer>
                <LoadingGif src={loadSCGif} alt="Carregando..." />
              </LoadingContainer>
            ) : (
              <Table
                firstColSmall={true}
                id="tabela-ficha-financeira"
                style={{ overflowX: "hidden" }}
              >
                <TableHead>
                  <TableRow>
                    <TableHeader>Nome do contribuinte</TableHeader>
                    <TableHeader>Cpf do contribuinte</TableHeader>
                    <TableHeader>Nosso Nº</TableHeader>
                    <TableHeader>Valor parcela</TableHeader>
                    <TableHeader>Valor ajuste</TableHeader>
                    <TableHeader>Valor pago</TableHeader>
                    <TableHeader>Valor tarifa</TableHeader>
                    <TableHeader>Data pagamento</TableHeader>
                    <TableHeader>Vencimento</TableHeader>
                    <TableHeader>Data geração</TableHeader>
                    {/* <TableHeader>Usuário geração</TableHeader> */}
                    <TableHeader>Código barras</TableHeader>
                    <TableHeader>QR Code Pix</TableHeader>
                    <TableHeader>Recibo</TableHeader>
                    <TableHeader>Remessa</TableHeader>
                    <TableHeader>Retorno</TableHeader>
                    <TableHeader>Status Impressão</TableHeader>
                    <TableHeader>Data caixa</TableHeader>
                    <TableHeader>Cadastrado pelo usuário</TableHeader>
                    {/* <TableHeader>Ações</TableHeader> */}
                  </TableRow>
                </TableHead>
                <tbody>
                  {record ? (
                    <TableRow key={`table ${record.id}`}>
                      <TableData style={{ textAlign: "center" }}>
                        {" "}
                        {record.contribuinte?.nome}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {" "}
                        {record.contribuinte?.cpfCin}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {" "}
                        {record.nossoNumero}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(Number(record.valorParcela))}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(Number(record.valorAjuste))}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(Number(record.valorPago))}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(Number(record.valorTarifa))}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.dataPagamento
                          ? formatarData(record.dataPagamento)
                          : "00/00/0000"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.dataVencimento
                          ? formatarData(record.dataVencimento as string)
                          : "-"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {new Intl.DateTimeFormat("pt-BR").format(
                          new Date(record.dataGeracao)
                        )}
                      </TableData>
                      {/* <TableData style={{ textAlign: "center" }}>
                        {record.usuarioGeracao
                          ? record.usuarioGeracao.charAt(0).toUpperCase() +
                            record.usuarioGeracao.slice(1)
                          : "N/A"}
                      </TableData> */}
                      <TableData style={{ textAlign: "center" }}>
                        {/* {" "}
                            {record.codigoBarras} */}
                        <Button
                          schemaButton="out-primary"
                          action={() => {
                            createBillOfPay([record]);
                          }}
                        >
                          Ver Boleto
                        </Button>
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        <Button
                          schemaButton="out-primary"
                          action={() => {
                            openModalQrCode();
                          }}
                        >
                          Ver QR Code
                        </Button>
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {recibo ? recibo.numeroSequencial : "N/A"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.remessa?.name ? record.remessa.name : "N/A"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.retorno?.fileName
                          ? record.retorno.fileName
                          : "N/A"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.statusImpressao}
                      </TableData>

                      <TableData style={{ textAlign: "center" }}>
                        {record.dataCaixa
                          ? formatarData(record.dataCaixa)
                          : "N/A"}
                      </TableData>
                      <TableData style={{ textAlign: "center" }}>
                        {record.userCreate ? record.userCreate.name : "N/A"}
                      </TableData>
                    </TableRow>
                  ) : (
                    <tr>
                      <TableData className="text-center text-muted" colSpan={2}>
                        Nenhuma parcela cadastrada.
                      </TableData>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button
            schemaButton="full-secondary"
            action={() => {
              onClose();
            }}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default DetailsModal;
